import { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import ImageComponent from '../../../components/common/Image';

const CustomToast = () => {
  useEffect(() => {
    // Helper function to render custom toast content
    const renderCustomToast = (msg, type) => {
      let toastContent;
    
      switch (type) {
        case 'success':
          toastContent = (
            <div className="success-alert"  aria-live="assertive" aria-atomic="true">
              <div className="d-flex card-body align-items-start gap-2">
                <ImageComponent fileName="circlele.svg" className="align-self-center" />
                <div>
                  <p className="fw-semibold text-success mb-0">Success <span className="d-block fw-light text-secondary">{msg}</span></p>
                </div>
              </div>
            </div>
          );
          break;
    
        case 'error':
          toastContent = (
            <div className="error-alert" aria-live="assertive" aria-atomic="true">
              <div className="d-flex card-body align-items-start gap-2">
                <ImageComponent fileName="cancelup.svg" className="align-self-center" />
                <div>
                  <p className="fw-semibold text-dark mb-0">Unable to Process <span className="d-block fw-light text-secondary">{msg}</span></p>
                </div>
              </div>
            </div>
          );
          break;
    
        case 'warning':
          toastContent = (
            <div className="warning-alert" aria-live="assertive" aria-atomic="true">
              <div className="d-flex card-body align-items-start gap-2">
                <ImageComponent fileName="exclaim.svg" className="align-self-center" />
                <div>
                  <p className="fw-semibold text-warning mb-0">Info! <span className="d-block fw-light text-secondary">{msg}</span></p>
                </div>
              </div>
            </div>
          );
          break;
    
        default:
          toastContent = (
            <div className="info-alert" aria-live="assertive" aria-atomic="true">
              <div className="d-flex card-body align-items-start gap-2">
                <ImageComponent fileName="exclaim.svg" className="align-self-center" />
                <div>
                  <p className="fw-semibold mb-0">Information <span className="d-block fw-light text-secondary">{msg}</span></p>
                </div>
              </div>
            </div>
          );
          break;
      }
    
      toast(toastContent, {
        closeButton: true,
        autoClose: 5000,
        position: "top-right",
        className: `custom-toast custom-toast-${type}`,
        hideProgressBar: true,
        draggable: true,
      });
    };

    // Override toast methods
    toast.success = (msg) => renderCustomToast(msg, 'success');
    toast.error = (msg) => renderCustomToast(msg, 'error');
    toast.warning = (msg) => renderCustomToast(msg, 'warning');
  }, []);

  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={true}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      className="custom-toast-container"
    />
  );
};

export default CustomToast;